"use client";

import { useEffect } from "react";
import { progress } from "@/services/nprogress";

export default function Loading() {
  useEffect(() => {
    // Inicia com anti-flicker (caso ainda não tenha iniciado pelo clique/popstate)
    progress.intentStart();

    // Finaliza no unmount — timing perfeito do fim do carregamento
    return () => {
      progress.forceDone();
    };
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="overlay light"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        inset: 0,
        width: "100%"
      }}
    >
      <img
        src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/spinner.svg"
        alt="Carregando"
        width={120}
        height={120}
      />
    </div>
  );
}
